export const MASTER_SCOPES = {
  PREFERRED_ADVISOR_LEVEL: "profile::preferred-advisor-level",
  PRIMARY_FUNCTION: "profile::primary-function",
  ADVISOR_PRIMARY_FUNCTION: "profile::advisor-primary-function",
  LOCATION: "location",
  EXPERIENCE: "profile::experience",
  ROLE_LEVEL: "profile::role-level",
  ORGANISATION_TYPE: "profile::organisation-type",
  GROWTH_AREA: "profile::growth-area",
  EXPERIENCE_CONTEXT: "profile::experience-context",
  ADVISOR_EXPERIENCE_CONTEXT: "profile::advisor-experience-context",
  FUNCTIONS_ADVISED: "profile::functions-advised",
  LEVELS: "profile::level",
  ADVISOR_LEVELS: "profile::advisor-level",
  ADVISORY_STYLE: "profile::advisory-style",
  ADVISORY_SCENARIOS: "advisory_scenarios",
  ACHIEVER_QUESTIONS: "achiever_questions",
  ADVISORY_TOP_AREAS: "profile::advisory-area",
  INDUSTRY: "profile::core-industries",
  JOB_TITLE: "profile::job-title",
  // Signup "Job Role" (HubSpot hs_role, 27) and "Industry" (HubSpot / LinkedIn
  // industry, 148). INDUSTRY above is the separate ForwardShare Core Industries list.
  JOB_ROLE: "profile::job-role",
  PROFILE_INDUSTRY: "profile::industry",
} as const;

export type MasterScope = (typeof MASTER_SCOPES)[keyof typeof MASTER_SCOPES];
